"use client";

import { Icon } from "@iconify/react";
import { getLocaleFromPathname } from "@/lib/i18n";
import { getSiteContent } from "@/lib/site-content";
import { usePathname } from "next/navigation";

export default function ContactPage() {
  const pathname = usePathname() || "/";
  const locale = getLocaleFromPathname(pathname);
  const content = getSiteContent(locale).contact;

  return (
    <div className="container mx-auto max-w-4xl px-4 py-12">
      <div className="mb-12 text-center">
        <h1 className="mb-6 text-4xl font-medium md:text-5xl">{content.title}</h1>
        <p className="inline-block rounded-md bg-positivus-green px-2 text-xl text-gray-700">
          {content.subtitle}
        </p>
      </div>

      <div className="grid gap-8 md:grid-cols-[1fr_300px]">
        <div className="space-y-6 rounded-[45px] border border-positivus-dark bg-positivus-grey p-8 shadow-[0_5px_0_0_#191A23] md:p-12">
          <div className="rounded-[24px] border border-positivus-dark bg-white p-6">
            <h2 className="mb-3 text-2xl font-medium">{content.emailUs}</h2>
            <p className="mb-4 text-gray-600">{content.subtitle}</p>
            <a
              href="mailto:support@dogufy.com"
              className="inline-flex rounded-[14px] border border-positivus-dark bg-positivus-green px-5 py-3 font-medium text-positivus-dark transition-colors hover:bg-positivus-dark hover:text-white"
            >
              support@dogufy.com
            </a>
          </div>

          <div className="rounded-[24px] border border-positivus-dark bg-white p-6">
            <h2 className="mb-3 text-2xl font-medium">{content.github}</h2>
            <p className="mb-4 text-gray-600">{content.githubBody}</p>
            <a
              href="https://github.com/Andikaa03/exodact"
              target="_blank"
              rel="noreferrer"
              className="inline-flex rounded-[14px] border border-positivus-dark px-5 py-3 font-medium text-positivus-dark transition-colors hover:bg-positivus-green"
            >
              {content.viewRepo}
            </a>
          </div>
        </div>

        <div className="space-y-6">
          <div className="rounded-[45px] border border-positivus-dark bg-positivus-green p-8">
            <Icon icon="mdi:email" className="mb-4 h-10 w-10 text-positivus-dark" />
            <h3 className="mb-2 text-xl font-medium">{content.emailUs}</h3>
            <a href="mailto:support@dogufy.com" className="break-all text-positivus-dark/80 hover:underline">
              support@dogufy.com
            </a>
          </div>

          <div className="rounded-[45px] border border-positivus-dark bg-white p-8">
            <Icon icon="mdi:github" className="mb-4 h-10 w-10 text-positivus-dark" />
            <h3 className="mb-2 text-xl font-medium">{content.github}</h3>
            <p className="mb-4 text-gray-600">{content.githubBody}</p>
            <a
              href="https://github.com/Andikaa03/exodact"
              target="_blank"
              rel="noreferrer"
              className="inline-block font-medium text-positivus-dark hover:underline decoration-2 underline-offset-4"
            >
              {content.viewRepo} &rarr;
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
